"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var timezones_list_1 = tslib_1.__importDefault(require("timezones-list"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var replace_1 = tslib_1.__importDefault(require("lodash/fp/replace"));
exports.default = map_1.default(function (_a) {
    var label = _a.label, tzCode = _a.tzCode;
    return ({
        label: pipe_1.default(replace_1.default('/', ' - '), replace_1.default('_', ' '))(label),
        value: tzCode,
    });
}, timezones_list_1.default);
